import { useEffect, useState } from "react";
import { fetchData } from "../function/util";
import { useParams } from 'react-router-dom';

const OrderConfirmation=()=>{
    const { id } = useParams();
    const [data, setData] = useState(null);

    useEffect(()=>{
        localStorage.clear();
        fetchData("order", {id})
        .then((result) => {
            setData(result);
        })
        .catch(() => {
            console.error('Error fetching data');
            window.location.href = "/";
        })
    }, [id]);
    return (
        <div className="main-content">
            {data&&<div className="d-flex flex-column justify-content-center align-items-center">
                <h3 className="p-3">Thank you for your order!</h3>
                <p>Your order has been successfully placed. You will receive a confirmation email shortly.</p>
                <h4 className="mb-3" style={{textDecoration: "underline"}}>Order Summary</h4>
                <div>
                    <table className="table table-bordered" style={{color: "#eee"}}>
                        <thead>
                            <tr>
                                <td align="center">Item</td>
                                <td align="center">Quantity</td>
                                <td align="center">Details</td>
                                <td align="center">$</td>
                            </tr>
                        </thead>
                        <tbody>
                            {data.cartDetails.cart.map((a, i)=>(
                            <tr key={i}>
                                <td>{a["name"]}</td>
                                <td>{a["quantity"]}</td>
                                <td>
                                    {a["sku"]["color"]&&a["sku"]["size"]
                                    ? (a["sku"]["color"] + "-" + a["sku"]["size"])
                                    : a["sku"]["size"]
                                    ?? a["sku"]["color"] ?? "-"
                                    }
                                </td>
                                <td>{parseFloat(a["sku"]["price"]).toFixed(2)}</td>
                            </tr>
                            ))}
                            {Object.keys(data.cartDetails.cartTotal).map((k, i)=>(
                            <tr key={i}>
                                <td colSpan={3}>{k.toUpperCase()}</td>
                                <td>{parseFloat(data.cartDetails.cartTotal[k]).toFixed(2)}</td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div>
                    <p>Tracking information will be emailed once available.</p>
                    <button className="mainbutton" onClick={()=>window.location.href="/"}>CONTINUE SHOPPING</button>
                </div>
            </div>}
        </div>
    )
}
export default OrderConfirmation;